import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { Header, HeaderOrganizationMenu } from '@/ui/components/header';
import { Breadcrumb, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { MainHeader, MainScrollArea } from '@/ui/components/main';
import { H1 } from '@/ui/components/heading';
import { Icon } from '@/ui/components/icon';
import { NewsIcon } from '@hugeicons-pro/core-stroke-rounded';
import { LATEST_RELEASE_NOTE_DATE } from '@/features/release-notes/constants';
import { releaseNotesSeenDateAtom } from '@/features/release-notes/store';
import { ReleaseNotesList } from '@/features/release-notes/components/release-notes-list';

export const Route = createFileRoute('/_authed/_organization/release-notes')({
  component: RouteComponent,
});

function RouteComponent() {
  const setSeenDate = useSetAtom(releaseNotesSeenDateAtom);

  useEffect(() => setSeenDate(LATEST_RELEASE_NOTE_DATE), [setSeenDate]);

  return (
    <>
      <Header>
        <HeaderOrganizationMenu />
        <Breadcrumb>
          <BreadcrumbPage>
            <Icon icon={NewsIcon} />
            {t({ en: 'Release notes', nb: 'Releasenotater' })}
          </BreadcrumbPage>
        </Breadcrumb>
      </Header>
      <MainScrollArea>
        <MainHeader className="items-start">
          <div className="flex max-w-2xl flex-col items-start gap-1.5">
            <H1>{t({ en: 'Release notes', nb: 'Releasenotater' })}</H1>
            <p className="text-muted text-sm">
              {t({
                en: "What's new in Volve, product and analysis updates that change how you work.",
                nb: 'Hva som er nytt i Volve, produkt- og analyseoppdateringer som endrer hvordan du jobber.',
              })}
            </p>
          </div>
        </MainHeader>
        <div className="max-w-2xl px-x pb-10">
          <ReleaseNotesList />
        </div>
      </MainScrollArea>
    </>
  );
}
